/* eslint-disable */
import Url from 'domurl'

const appendSocial = (elementId, param) => {
    const element = document.getElementById(elementId)
    const oldUrl = element.getAttribute('href')
    const newUrl = insertBeforeLastOccurence(
        oldUrl,
        '&',
        `%3FaddToWishlist%3D${param}`
    )
    element.setAttribute('href', newUrl)
}

const addToWishlistParamToLogin = (param) => {
    const element = document.getElementById('login')
    const url = new Url(element.getAttribute('href'))
    url.query.addToWishlist = param
    element.setAttribute('href', url.toString())
}

const insertBeforeLastOccurence = (strToSearch, strToFind, strToInsert) => {
    const n = strToSearch.lastIndexOf(strToFind)
    if (n < 0) return strToSearch
    return strToSearch.substring(0, n) + strToInsert + strToSearch.substring(n)
}

export default function appendIdToAccountLinks(param) {
    addToWishlistParamToLogin(param)
    appendSocial('signup-facebook', param)
    appendSocial('signup-google', param)
}
